/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Text_To_AudioInputs */

const en_dashboard_text_to_audio = /** @type {(inputs: Dashboard_Text_To_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste Text`)
};

const es_dashboard_text_to_audio = /** @type {(inputs: Dashboard_Text_To_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pegar texto`)
};

/**
* | output |
* | --- |
* | "Paste Text" |
*
* @param {Dashboard_Text_To_AudioInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dashboard_text_to_audio = /** @type {((inputs?: Dashboard_Text_To_AudioInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Text_To_AudioInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dashboard_text_to_audio(inputs)
	return en_dashboard_text_to_audio(inputs)
});